module.exports = __webpack_public_path__ + "img/teacher.00c32555.png";